/**
 * @desc sku销售预测保存草稿
 */
const URL = "/rantion-basics";
import http, { updateResponse } from "@/http";
export type Response = defs.basics.ResponseDto<string>;
export function request(
  body: defs.basics.PlmSkuForecastCreateRequestDto,
  options?: any,
): Promise<Response> {
  return updateResponse(
    http(URL + `/product/sku/skuForecastSaveDraft`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
